module.exports = __webpack_public_path__ + "img/pos-icon-active.3d2850ee.svg";